/* eslint-disable class-methods-use-this */
/* eslint-disable class-methods-use-this */
import { formatDate } from 'utils/Common/date-utils'
import { handleMimeType } from 'utils/Documents/document-utils'
import DocumentTableAPI from 'utils/__interfaces/Documents/DocumentTableAPI'
import DocumentTableEntity from 'utils/__interfaces/Documents/DocumentTableEntity'

class DocumentTableNormalizer {
  normalize(tableDocument: DocumentTableAPI[]): DocumentTableEntity[] {
    return tableDocument.map((item) => {
      return {
        id: `${item.id};${item.filename}`,
        companyIds: item.companies.map((item) => item.companyId),
        organisationIds: item.organisations.map((item) => item.organisationId),
        filename: item.filename,
        docTypeLabel: item.docType.label,
        docFamilyLabel: item.docType.docFamily.label,
        name: item.name,
        mimeType: handleMimeType(item.mimeType),
        expireAt: item.expireAt
          ? formatDate(item.expireAt, 'DD/MM/YYYY')
          : undefined,
        createdAt: item.createdAt
          ? formatDate(item.createdAt, 'DD/MM/YYYY')
          : undefined,
      }
    })
  }
}

export default new DocumentTableNormalizer()
